import { useState } from 'react';
import { useLazyWorkplaceOnlineOrderingSetupQuery } from '../../../graphql/graphql';
import { useEffectAsync } from '../../../helpers';
import useLoading from '../../Base/Hooks/useLoading';
import useApiClient from '../../Base/Hooks/useApiClient';

export default function useOnlineOrderTarget(workplaceId: string) {
	const [onlineOrderTarget, setOnlineOrderTarget] = useState<
		string | undefined
	>();
	const { setIsLoading, isLoading } = useLoading();
	const { displayGQLError } = useApiClient();
	const [getWorkplaceOnlineOrderTarget] =
		useLazyWorkplaceOnlineOrderingSetupQuery();

	const loadWorkplaceOnlineOrderTarget = async () => {
		setIsLoading(true);
		const response = await getWorkplaceOnlineOrderTarget({ id: workplaceId });

		displayGQLError(response);
		if ('data' in response) {
			setOnlineOrderTarget(
				response.data?.workplace?.onlineOrderTarget ?? undefined,
			);
		}
		setIsLoading(false);
	};

	useEffectAsync(async () => {
		await loadWorkplaceOnlineOrderTarget();
	}, []);

	return {
		isLoading,
		onlineOrderTarget,
		refetchOnlineOrderTarget: loadWorkplaceOnlineOrderTarget,
	};
}
